setInterval(() => {
    if (window.location.hash === '#show-nector-rewards') {
      document.querySelector('.RQCartDRawerExecutionmWp')?.classList.remove('active');
    }
    const element = document.querySelector('.nector-cart-balance');
    if (element && element.textContent && !element.textContent.includes('₹')) {
      const balance = parseInt(element.textContent);
      if (balance === 0) {
        document.querySelector('.nector-cart-balance-container').style.display = 'none';
      } else {
        const subtotal = document.querySelector('.totals__subtotal-value')?.textContent?.replace(/[^0-9]/g, '');
        const maxFromSubtotal = subtotal ? Math.floor(subtotal * 0.3) : 0;
        const value = Math.min((balance / 10), 200, maxFromSubtotal);
        element.textContent = `₹${value}`;
      }
    }
  }, 100);
  $(".main_product_image-wrapp_mobile .swiper-wrapper").on("touchend", function () {
    setTimeout(function () {
      let activeSlide = $(".main_product_image-wrapp_mobile .swiper-slide-active");
      let dataImage = activeSlide.attr("data-image");
        if (dataImage) {
            $(".thumbnails_image-wrapp .thumb_image_inner").removeClass("is-nav-selected"); // Remove from all
            $(".thumbnails_image-wrapp .thumb_image_inner").each(function () {
                  if ($(this).attr("data-image") === dataImage) {
                      $(this).addClass("is-nav-selected");
                  }
              });
        }
      }, 100); // Timeout to ensure Swiper updates before running
  });
  $(".thumbnails_image-wrapp").on("click", ".thumb_image_inner", function () {
    $(".thumbnails_image-wrapp .thumb_image_inner").removeClass("is-nav-selected"); // Remove from all
    $(this).addClass("is-nav-selected"); // Add only to clicked one
});